import React from 'react';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import {Modal, ModalButtons} from 'shared/components/modals';
import {FormLayout, Input, Select2} from 'shared/components';

const EditDocumentFolderModal = observer(({uiState}) => {
  const {errors, editingFolder, parentFolderOptions} = uiState;

  return (
    <Modal isOpen={uiState.editDocumentFolderModalOpen} onHide={() => uiState.closeEditDocumentFolderModal()} size='sm'>
      <div className='h2 medium mb3'>
        <FormattedMessage id={uiState.editMessage}/>
      </div>
      <FormLayout>
        <Input
          label='company_settings.document_folders.Folder Name'
          value={editingFolder.name}
          errorMessage={errors.name}
          onChange={(e) => editingFolder.merge({name: e.target.value})}
        />
        <Select2
          label='company_settings.document_folders.Parent Folder'
          value={editingFolder.parentId}
          onChange={e => editingFolder.merge({parentId: e.target.value})}
          errorMessage={errors.base}
          allowClear
        >
          {parentFolderOptions.map(folder => (
            <option value={folder.id} key={folder.id}>{folder.name}</option>
          ))}
        </Select2>
      </FormLayout>
      <ModalButtons onSave={() => uiState.saveDocumentFolder()} onCancel={() => uiState.closeEditDocumentFolderModal()}/>
    </Modal>
  );
});

export default EditDocumentFolderModal;
